export const LockIcon: React.FC<React.SVGProps<SVGSVGElement>> = ({
  fill,
  ...props
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    {...props}
  >
    <title>Lock</title>
    <path
      d="M12 5.33342H11.3333V4.00008C11.3333 2.16008 9.84 0.666748 8 0.666748C6.16 0.666748 4.66667 2.16008 4.66667 4.00008V5.33342H4.00001C3.26667 5.33342 2.66667 5.93341 2.66667 6.66675V13.3334C2.66667 14.0667 3.26667 14.6667 4.00001 14.6667H12C12.7333 14.6667 13.3333 14.0667 13.3333 13.3334V6.66675C13.3333 5.93341 12.7333 5.33342 12 5.33342ZM8 11.3334C7.26667 11.3334 6.66667 10.7334 6.66667 10.0001C6.66667 9.26675 7.26667 8.66675 8 8.66675C8.73334 8.66675 9.33334 9.26675 9.33334 10.0001C9.33334 10.7334 8.73334 11.3334 8 11.3334ZM10.0667 5.33342H5.93334V4.00008C5.93334 2.86008 6.86 1.93341 8 1.93341C9.14 1.93341 10.0667 2.86008 10.0667 4.00008V5.33342Z"
      fill={fill || "#F7F7F7"}
    />
  </svg>
);
